var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2437 14.4162C16.5483 13.5025 17.5635 12.8934 18.5787 12.9949C18.0711 12.1827 17.1574 11.6751 16.2437 11.5736C15.7361 12.4873 15.2285 13.2995 14.6193 14.1117L14.5178 12.7919L14.9239 12.2843C14.5178 12.3858 14.0102 12.3858 13.5026 12.2843L13.9087 12.7919L13.8071 14.0101C13.198 13.198 12.6904 12.3858 12.2843 11.4721C11.5736 11.4721 10.7614 11.7766 10.2538 12.3858C9.6447 13.198 9.34013 14.2132 9.54317 15.2284C9.74622 16.2436 11.1675 16.3452 11.1675 16.3452H16.5482C16.1422 15.8376 16.0406 15.0254 16.2437 14.4162Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7766 8.8325C12.0812 11.8782 14.1117 11.8782 14.1117 11.8782C14.1117 11.8782 14.1117 11.8782 14.2132 11.8782C16.4467 11.7767 16.5482 8.62945 16.5482 8.62945C16.5482 8.52793 16.5482 8.52793 16.5482 8.42641C16.5482 7.10661 15.4315 5.98986 14.1117 5.88834C11.5736 6.09138 11.7766 8.8325 11.7766 8.8325ZM16.0406 8.8325L16.2436 8.62945C16.1421 11.4721 14.1117 11.6751 14.1117 11.6751C12.2842 11.3706 12.0812 8.93402 12.0812 8.93402L12.3858 9.03554V7.81727C12.3858 7.61422 12.5888 7.5127 12.6903 7.5127C13.604 7.91879 14.6193 7.91879 15.4315 7.5127C15.8375 7.91879 16.0406 8.32488 16.0406 8.8325Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1726 13.2995C17.1573 13.2995 16.3452 14.1117 16.3452 15.1269C16.3452 16.1421 17.1573 16.9543 18.1726 16.9543C19.1878 16.9543 20 16.1421 20 15.1269C20 14.1117 19.1878 13.2995 18.1726 13.2995ZM19.3908 15.1269H19.0863L18.9847 15.533L19.0863 15.8376L18.9847 15.9391L18.7817 15.8376L18.3756 16.0406V16.3452H18.2741L18.1726 16.0406L17.7665 15.8376L17.5634 15.9391L17.4619 15.8376L17.5634 15.6345L17.3604 15.2284H17.0558V15.1269H17.2589L17.4619 14.6193L17.3604 14.4163L17.4619 14.3147L17.6649 14.4163L18.071 14.3147V14.0102H18.2741V14.3147L18.6802 14.5178L18.9847 14.3147L19.0863 14.4163L18.9847 14.7208L19.0863 15.1269H19.3908V15.1269Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1726 14.5178C17.868 14.5178 17.5635 14.8223 17.5635 15.1269C17.5635 15.4315 17.868 15.736 18.1726 15.736C18.4772 15.736 18.7818 15.4315 18.7818 15.1269C18.7818 14.8223 18.4772 14.5178 18.1726 14.5178ZM18.1726 15.3299C17.9696 15.3299 17.868 15.2284 17.868 15.0254C17.868 14.8223 17.9696 14.7208 18.1726 14.7208C18.3757 14.7208 18.4772 14.8223 18.4772 15.0254C18.4772 15.2284 18.3757 15.3299 18.1726 15.3299Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2995 17.868V18.5787H1.42132V1.3198H10.6599V3.75635C10.6599 3.95939 10.9645 4.06091 10.9645 4.06091H13.401V4.97462C13.9086 4.97462 14.3147 4.97462 14.7208 5.27919V2.94416L11.5736 0H0.507614C0.203046 0 0 0.203046 0 0.507614V19.2893C0.101523 19.5939 0.203046 19.797 0.507614 19.8985H14.4162C14.6193 19.797 14.8223 19.5939 14.8223 19.3909V17.7665L13.2995 17.868Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81723 4.06091H2.74109V5.07614H7.81723V4.06091Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81723 6.09137H2.74109V7.1066H7.81723V6.09137Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81723 8.12183H2.74109V9.13705H7.81723V8.12183Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81723 10.1523H2.74109V11.1675H7.81723V10.1523Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81723 12.1827H2.74109V13.198H7.81723V12.1827Z",
    fill: "#60605F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81723 14.2132H2.74109V15.2284H7.81723V14.2132Z",
    fill: "#60605F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNew);
export default __webpack_public_path__ + "static/media/setting_new.9d6a2dfd5c37379947fb30f6d3478486.svg";
export { ForwardRef as ReactComponent };